exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".challenge[data-v-759f9d58]{background-color:#f74a4b!important}@media screen and (max-width:766px){#confirm-button-container button[data-v-759f9d58]{width:100%}}", ""]);

// exports
